<template>
    <main id="mainCtrl">
        <services-tree ref="servicesTree"
                       :is-support="isSupport"
                       :all-prices="prices"
                       :treetable="treetable"/>
    </main>
</template>

<script>
import ServicesTree from "../../components/common/services/Tree.vue";

export default {
    components: {
        ServicesTree,
    },
    props: {
        isSupport: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            prices: {},
            treetable: [],
        };
    },
    mounted: function () {
        this.refresh();
    },
    methods: {
        refresh: function () {
            this.$refs.servicesTree.$refs.servicesTable.startLoadingAnimation();
            this.axios.post('services/getPrices')
                .then((response) => {
                    this.prices = response.data;

                    this.axios.post('services/treetableData')
                        .then((response) => {
                            this.treetable = response.data;

                            this.$refs.servicesTree.$refs.servicesTable.stopLoadingAnimation();
                        });
                });
        },
    },
}
</script>
